import { render, staticRenderFns } from "./ShowImageAvatarDialog.vue?vue&type=template&id=2e6abe52&scoped=true"
import script from "./ShowImageAvatarDialog.vue?vue&type=script&lang=js"
export * from "./ShowImageAvatarDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e6abe52",
  null
  
)

export default component.exports